import type { Attachment } from "svelte/attachments";

type Listener = (width: number, height: number) => void;

const listeners = new WeakMap<Element, Listener>();

let watcher: ResizeObserver | null = null;

const observer = (): ResizeObserver => {
  watcher ??= new ResizeObserver((entries) => {
    for (const entry of entries) {
      const [box] = entry.contentBoxSize;
      if (box !== undefined)
        listeners.get(entry.target)?.(Math.round(box.inlineSize), Math.round(box.blockSize));
    }
  });
  return watcher;
};

export const resized =
  (listener: Listener): Attachment =>
  (node) => {
    const watching = observer();
    listeners.set(node, listener);
    const style = getComputedStyle(node);
    const across =
      node.clientWidth - parseFloat(style.paddingLeft) - parseFloat(style.paddingRight);
    const down = node.clientHeight - parseFloat(style.paddingTop) - parseFloat(style.paddingBottom);
    if (across > 0) listener(Math.round(across), Math.round(Math.max(0, down)));
    watching.observe(node);
    return () => {
      watching.unobserve(node);
      listeners.delete(node);
    };
  };
